<div class="root">
  <div #itemsParent class="list-overflow-parent" [ngClass]="{ 'opacity-0': !initialized, 'has-border': hasBorder() }">

    <ul class="ul-unstyle d-flex">
      @for (item of items(); track item.label; let id = $index) {
        @if (!item.isDisplayed || item.isDisplayed()) {
          <li class="d-inline-block" [id]="getId(id)" #itemsRendered [style]="{ visibility: showItemsUntilIndexExcluded && id >= showItemsUntilIndexExcluded ? 'hidden' : 'inherit' }">
            <ng-container *ngTemplateOutlet="itemTemplate(); context: {item: item}"></ng-container>
          </li>
        }
      }
    </ul>

    @if (isMenuDisplayed()) {
      @if (isInMobileView) {
        <button type="button" class="peertube-button tertiary-button p-0 list-overflow-menu overflow-button" (click)="toggleModal()">
          <span class="chevron-down"></span>
        </button>
      }

      <div [hidden]="isInMobileView" class="list-overflow-menu" ngbDropdown container="body" #dropdown="ngbDropdown">
        <button class="peertube-button tertiary-button p-0 overflow-button" ngbDropdownToggle type="button">
          <span class="chevron-down"></span>
        </button>

        <ul class="ul-unstyle" ngbDropdownMenu>
          @for (item of items() | slice:showItemsUntilIndexExcluded:items().length; track item.label) {
            @if (!item.isDisplayed || item.isDisplayed()) {
              <li>
                <ng-container *ngTemplateOutlet="itemTemplate(); context: {item: item, dropdown: true}"></ng-container>
              </li>
            }
          }
        </ul>
      </div>
    }
  </div >

  <ng-template #modal let-close="close" let-dismiss="dismiss">
    <div class="modal-body">
      <ul class="ul-unstyle">
        @for (item of items() | slice:showItemsUntilIndexExcluded:items().length; track item.label) {
          @if (!item.isDisplayed || item.isDisplayed()) {
            <li>
              <ng-container *ngTemplateOutlet="itemTemplate(); context: {item: item, modal: true}"></ng-container>
            </li>
          }
        }
      </ul>
    </div>
  </ng-template>
</div>
